import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import {
  Close as CloseIcon,
  PlayCircleOutline as PlayIcon,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import { ICourseViewDialogProps } from "../types/video-view";
import { getEmbedUrl } from "../utils/GetEmbededUrl";

const CourseViewDialog: React.FC<ICourseViewDialogProps> = ({
  open,
  onClose,
  course,
}) => {
  if (!course) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      component={motion.div}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Course Preview</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: "flex", height: "70vh" }}>
          {/* Video/Content Area */}
          {/* Video/Content Area */}
          <Box sx={{ flex: 1, bgcolor: "#000", position: "relative" }}>
            {course.youtube_url ? (
              <iframe
                src={getEmbedUrl(course.youtube_url)}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                title="HOW TO DISMANTLE THE TV STAND"
              />
            ) : (
              <img
                src={course.image || "/placeholder.svg"}
                alt={course.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            )}
          </Box>

          {/* Lesson Sidebar */}
          <Box
            sx={{
              width: 350,
              bgcolor: "#f5f5f5",
              borderLeft: "1px solid #ddd",
            }}
          >
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" gutterBottom>
                {course.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                {course.description}
              </Typography>
            </Box>

            <Divider />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CourseViewDialog;
